import { MemberFragment } from '@/schemas/getCoreCompanyMembersByCompanyIdQuery';
import { TypedDocumentNode, gql } from '@apollo/client';
import { BASE_USERS, CompanyUsers } from './getCompanyUsersById';
import { MembersType } from './getSignatoriesByCompanyId';

type getAllPotentialCompanyUsersByIdType = {
  orders_companies_by_pk: {
    company_users: CompanyUsers;
    core_company: MembersType;
  };
};

const PotentialUsersFragment = gql`
  ${BASE_USERS}
  fragment PotentialUsers on orders_companies {
    company_users(
      where: {
        _and: {
          is_active: { _eq: true }
          invitation_accepted_at: { _is_null: false }
        }
      }
    ) {
      ...BaseUsers
      can_sign_alone
      member_id
      invitation_accepted_at
      last_login
      is_ubo
      invitations(where: { company_id: { _eq: $companyId } }) {
        invited_by_id
        invited_user_id
        created_at
        accepted_at
        is_accepted
      }
    }
  }
`;

export const MembersFragment = gql`
  ${MemberFragment}
  fragment PotentialMembers on lager_core_company {
    members(where: { is_person: { _eq: true } }) {
      ...CoreMember
    }
  }
` as TypedDocumentNode<MembersType>;

type getAllPotentialCompanyUsersByIdQueryVariables = { companyId?: number };
export const getAllPotentialCompanyUsersByIdQuery = gql`
  ${PotentialUsersFragment}
  ${MembersFragment}
  query getAllPotentialCompanyUsersById($companyId: bigint!) {
    orders_companies_by_pk(id: $companyId) {
      id
      ...PotentialUsers
      core_company {
        id: uid
        ...PotentialMembers
      }
    }
  }
` as TypedDocumentNode<
  getAllPotentialCompanyUsersByIdType,
  getAllPotentialCompanyUsersByIdQueryVariables
>;
